import { createCheckoutAttemptId } from './analytics-context.js';
import { SATELLITE_POPUP_EXPERIMENT, satellitePopupAttribution, type SatellitePopupAttribution } from '../shared/satellite-popup.js';

export const SATELLITE_POPUP_STORAGE_KEY = `drawonamap:experiment:${SATELLITE_POPUP_EXPERIMENT}`;

// Failed storage means no enrollment. A page-only assignment can cross groups on return.
export function getSatellitePopupAssignment(
  storage: Pick<Storage, 'getItem' | 'setItem'> | null,
  random: () => number = Math.random,
  createId: () => string | null = createCheckoutAttemptId,
): SatellitePopupAttribution | null {
  if (!storage) return null;
  try {
    const stored = storage.getItem(SATELLITE_POPUP_STORAGE_KEY);
    if (stored) {
      const record = JSON.parse(stored);
      const assignment = satellitePopupAttribution('satellite_basemap', record?.popup_experiment, record?.popup_variant, record?.popup_exposure_id);
      if (assignment) return assignment;
    }
    const assignment = satellitePopupAttribution('satellite_basemap', SATELLITE_POPUP_EXPERIMENT, random() < 0.5 ? 'control' : 'feature_demo', createId());
    if (!assignment) return null;
    const serialized = JSON.stringify(assignment);
    storage.setItem(SATELLITE_POPUP_STORAGE_KEY, serialized);
    return storage.getItem(SATELLITE_POPUP_STORAGE_KEY) === serialized ? assignment : null;
  } catch { return null; }
}

export function satellitePopupAssignment(): SatellitePopupAttribution | null {
  try { return getSatellitePopupAssignment(window.localStorage); } catch { return null; }
}
